import Vue from 'vue'
import { AZURE_B2C_INSTANCE, AZURE_B2C_TENANT, AZURE_B2C_SIGN_IN_POLICY, AZURE_B2C_CLIENT_ID, AZURE_B2C_SCOPES } from '@/common/config'
import {Permissions} from '../helpers/permissions'
import {Role} from '../helpers/role'


const PermissionRoleMapping = {};
PermissionRoleMapping[Permissions.Impersonate] = [Role.Admin];

const { location } = window;
const authConfig = {
    instance: AZURE_B2C_INSTANCE,
    tenant: AZURE_B2C_TENANT,
    signInPolicy: AZURE_B2C_SIGN_IN_POLICY,
    clientId: AZURE_B2C_CLIENT_ID,
    scopes: AZURE_B2C_SCOPES,
    redirectUri: `${location.origin}/verify-token`,
    responseType: 'token',
    prompt: 'login',
    responseMode: 'query'
  };

export const AuthService = {
    isAuthenticated () {
        return Vue.$jwt.hasToken();
    },
    getToken(){
        return Vue.$jwt.getToken();
    },
    getDecodedToken() {
        return Vue.$jwt.decode();
    },
    setToken(token) {
        localStorage.setItem('auth_token', token);
    },
    isValidToken() {
        var token = this.getDecodedToken();
        if(token.isForgotPassword){
            return false;
        }
        if (this.hasAccessTokenExpired()){
            return false;
        }
        return true;
    },
    hasAccessTokenExpired() {
        const token = this.getDecodedToken();
        return typeof token !== 'object'
            || isNaN(token.exp)
            || Date.now() >= token.exp * 1000;
    },
    hasAnyRole(roles) {
        const payload = this.getDecodedToken();
        if(payload) {
            return roles.includes(payload.extension_Role)
        }
        return false;
    },
    hasRole(role) {
        const payload = this.getDecodedToken();
        if(payload) {
            return role == payload.extension_Role;
        }
        return false;
    },
    getUserName() {
        const payload = this.getDecodedToken();
        if(payload) {
            return roles.includes(payload.name)
        }
        return false;
    },
    getUserRole() {
        const payload = this.getDecodedToken();
        if(payload) {
            return payload.extension_Role;
        }
        return false;
    },
    getUserId() {
        const payload = this.getDecodedToken();
        if(payload) {
            return payload.extension_UserId;
        }
        return null;
    },
    login() {
        const authority = `${authConfig.instance}/${authConfig.tenant}/${authConfig.signInPolicy}`;
        const responseType = `response_type=${authConfig.responseType}`;
        const scopes = `scope=${encodeURI(authConfig.scopes)}`;
        const clientId = `client_id=${authConfig.clientId}`;
        const redirectUri = `redirect_uri=${authConfig.redirectUri}`;
        const prompt = `prompt=${authConfig.prompt}`;
        const responseMode = `response_mode=${authConfig.responseMode}`;
        const authUrl =  `${authority}/oauth2/v2.0/authorize?${responseType}&${scopes}&${clientId}&${redirectUri}&${prompt}&${responseMode}`;

        location.href = authUrl;
    },
    logout() {
        localStorage.clear();
    },
    hasPermission(permission) {
        if(permission == null || permission == undefined){
            return false;
        }
        if(PermissionRoleMapping.hasOwnProperty(permission))
        {
            return this.hasAnyRole(PermissionRoleMapping[permission]);
        }
        return false;
    }
}

